import { useCallback, useEffect, useRef, useState } from 'react';
import { createCircuitEngine } from '@/lib/circuitEngine';
import CircuitNote from '@/components/CircuitNote';

// Global overlay: cyan circuit traces bloom from every click/press.
export default function CircuitClickEffect() {
  const ref = useRef(null);
  const [note, setNote] = useState(null);
  const clearNote = useCallback(() => setNote(null), []);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const hsl = window.getComputedStyle(document.documentElement).getPropertyValue('--primary').trim().replace(/\s+/g, ', ');
    const engine = createCircuitEngine(ref.current, (a) => `hsla(${hsl}, ${a})`,
      ({ x, y, held }) => { if (held >= 2000) setNote({ x, y, id: Date.now() }); });
    engine.resize();
    const down = (e) => { if (e.button === 0) engine.down(e.clientX, e.clientY); };
    const move = (e) => engine.move(e.clientX, e.clientY);
    const up = () => engine.up();
    window.addEventListener('resize', engine.resize);
    window.addEventListener('pointerdown', down, { passive: true });
    window.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
    window.addEventListener('blur', up);
    return () => {
      engine.destroy();
      window.removeEventListener('resize', engine.resize);
      window.removeEventListener('pointerdown', down);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      window.removeEventListener('pointercancel', up);
      window.removeEventListener('blur', up);
    };
  }, []);

  return (
    <>
      <canvas ref={ref} aria-hidden="true" className="fixed inset-0 w-screen h-screen pointer-events-none z-[9999]" />
      {note && <CircuitNote key={note.id} x={note.x} y={note.y} onDone={clearNote} />}
    </>
  );
}